import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgShield = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.3586 20.6828C11.5639 20.7898 11.6666 20.8433 11.809 20.8711C11.92 20.8926 12.08 20.8926 12.191 20.8711C12.3334 20.8433 12.4361 20.7898 12.6414 20.6828C14.54 19.6936 20 16.461 20 11.9999V8.21747C20 7.41796 20 7.0182 19.8692 6.67457C19.7537 6.37101 19.566 6.10015 19.3223 5.8854C19.0465 5.64231 18.6722 5.50195 17.9236 5.22122L12.5618 3.21054C12.3539 3.13258 12.25 3.0936 12.143 3.07815C12.0482 3.06444 11.9518 3.06444 11.857 3.07815C11.75 3.0936 11.6461 3.13258 11.4382 3.21054L6.0764 5.22122C5.3278 5.50195 4.9535 5.64231 4.67766 5.8854C4.43398 6.10015 4.24627 6.37101 4.13076 6.67457C4 7.0182 4 7.41796 4 8.21747V11.9999C4 16.461 9.45996 19.6936 11.3586 20.6828Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgShield;
